import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import promise from 'redux-promise';
import thunk from 'redux-thunk';
import reducers from './reducers';
import { paneOpts } from './actions';
import App from './components/App/App';

// the id of the div for render
let appId = 'fundchar';
let isFP = false;
let isLoggedIn = false;
const version = `${process.env.REACT_APP_VERSION}`
  ? `${process.env.REACT_APP_VERSION}`
  : 'VDEV';

// load attributes from script tag
function getSyncScriptParams() {
  const scripts = document.getElementsByTagName('script');
  const lastScript = scripts[scripts.length - 1];
  const scriptName = lastScript;
  // override from attributes if they exist
  if (scriptName.getAttribute('appId')) {
    appId = scriptName.getAttribute('appId');
  }
  if (scriptName.getAttribute('mode')) {
    isFP = scriptName.getAttribute('mode') === 'fp' ? true : false;
  }
}
getSyncScriptParams();

//load any funds passed in the url
let initialTickers = [];
const tickers = window.location.search.split('tickers=')[1];
if (tickers) {
  initialTickers = tickers.split(',');
}

// optionally read customid so we can pass to salesforce.
const hash = window.location.hash;
const hashParams = new URLSearchParams(hash.split('&').slice(1).join('&'));
const unauthUserEmail = hashParams.get('email');

// for individual page set params from window.fundchar
let advisorEmail = '';
let pdfReportConfigId = '';
let wtRegion = 'US';
let token = null;

if (window.fundchar) {
  if (window.fundchar.clientEmail) {
    advisorEmail = window.fundchar.clientEmail;
  }
  if (window.fundchar.wtRegion) {
    wtRegion = window.fundchar.wtRegion;
  }
  if (window.fundchar.pdfReportConfigId) {
    pdfReportConfigId = window.fundchar.pdfReportConfigId;
  }
}

// stop runtime errors (after upgrading react tool tip)
window.addEventListener('error', (event) => {
  if (
    event.message.includes(
      'ResizeObserver loop completed with undelivered notification'
    )
  ) {
    event.stopImmediatePropagation();
    event.stopPropagation();
    console.warn('Handled ResizeObserver errror:', event);
  }
});

// for dashboard try window.portfolioMapper
if (window.portfolioMapper) {
  if (window.portfolioMapper.clientEmail) {
    advisorEmail = window.portfolioMapper.clientEmail;
  }
  if (window.portfolioMapper.wtRegion) {
    wtRegion = window.portfolioMapper.wtRegion;
  }
  if (window.portfolioMapper.token) {
    token = window.portfolioMapper.token;
  }
}

if (
  advisorEmail.includes('@') &&
  advisorEmail.includes('.') &&
  advisorEmail.length > 4
) {
  isLoggedIn = true;
}

if (window.isFP === true) {
  isFP = true;
}

// default params state
const params = {
  isFP: isFP,
  initialTickers: initialTickers,
  isLoggedIn: isLoggedIn,
  advisorEmail: advisorEmail,
  unauthUserEmail: unauthUserEmail, // <- this is not to be confused with advisorEmail. It an email tagged to the url for SF tracking purposes
  wtRegion: wtRegion,
  selectedFunds: [],
  selectedFundsWhole: [],
  fcBottomSelected: 'show',
  selectedChars: [],
  selectedSector: '',
  selectedCountry: '',
  activePane: paneOpts.metrics,
  activeSoePane: 'Summary',
  activeSoeDataType: 'Country',
  version: version,
  token: token,
  selectedRelated: false,
  perfStartDate: null,
  perfEndDate: null,
  fullExcelStatus: false,
  currentExcelStatus: false,
  currentURL: '',
  growthMetricQuality: 'median',
  growthMetricQtyHistoricFlag: false,
  pdfReportConfigId: pdfReportConfigId,
  seeAdditionalPIFlag: false,
  showFundSelection: true,
  screenedFunds: [],
  tickerSearch: [],
  drawdownNumber: '10',
};

// default sampleData state
const fundData = {
  relatedFunds: [],
  filteredData: [],
  catFunds: [],
  loading: false,
  error: false,
  loadingSearchResults: false,
  pendingDataspanRequests: [], //this is used to cancle axios requests to dataspan if the user moves away (speed purposes)
};

const data = {
  personalStrategies: null,
  strategyIdToShow: null,
};

// console.log('params', params)
// console.log('fundData', fundData)
// console.log('data', data)
// render
ReactDOM.render(
  <BrowserRouter>
    <Provider
      store={createStore(
        reducers,
        { params: params, fundData: fundData, data: data },
        applyMiddleware(promise, thunk)
      )}
    >
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById(appId)
);
